export function getCurrentEnvironment(): 'production' | 'staging' | 'preview' | 'development' {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname

    if (hostname.endsWith('.preview.poweredbyash.io')) {
      return 'preview'
    } else if (hostname.endsWith('.staging.poweredbyash.io')) {
      return 'staging'
    } else if (hostname.endsWith('.poweredbyash.io')) {
      return 'production'
    } else {
      return 'development'
    }
  }

  const vercelEnv = process.env.VERCEL_TARGET_ENV
  if (vercelEnv === 'production') return 'production'
  if (vercelEnv === 'staging') return 'staging'
  if (vercelEnv === 'preview') return 'preview'
  if (process.env.NODE_ENV === 'development') return 'development'

  return 'development'
}
